const __WEBPACK_NAMESPACE_OBJECT__ = {"apiUrl":"https://api.huixquilucanempleo.com:11002","gaMeasurementId":"","enableFakeBackend":false};